

import {  useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import TitleIcon from '@mui/icons-material/Title';
import { useForm } from "react-hook-form";
import apiService from "../../../api/ApiService";
import { useGlobalContext } from "../../Context";
import { isEqual } from "../../EditModalDam";
import { AddStatus } from "../../../redux/slices/warningSlice";
import { Close, ImportantDevices } from "@mui/icons-material";

const moment=require('moment-jalaali');


const EditStatus=({penr,flag,toggle,iindex,important})=>{
    const {currentWarings}=useSelector(state=>state.warning)
    const [valid,setValid]=useState(false)
    
    
    const {openModalls,isOpenModal,closeModalls,openModallComment,closeModallComment,isModalCommentOpen}=useGlobalContext();
    const mainProp={
        title:penr?.title,id:penr?.id,importanceLevel:penr?.importanceLevel
      }
    const dispatch=useDispatch();
    const {watch,
        register,
        handleSubmit,
        formState: { errors }
      } = useForm({defaultValues:mainProp});
    const allData=watch()
    useEffect(()=>{setValid(isEqual(mainProp,allData))},[allData])


    

    const updatePen=async(data)=>{  
        const list=currentWarings.map(item=>{
            return +item?.id
        })     
        const GenerateId = list.length === 0 ? 0 : 1 + Math.max(...list);
                    switch(flag){
                        case 1:
                            if(toggle==='edit'){
                                const data1=JSON.stringify({...data,id:penr?.id,importanceLevel:+data?.importanceLevel})
                            const res=await apiService.editStatusItem(data1);
                            const editedList = [
                                ...currentWarings.slice(0,iindex),
                                res.data,
                                ...currentWarings.slice(iindex+1)
                              ];
                            dispatch(AddStatus(editedList))
                            openModalls()
                            }
                            if(toggle==='add'){
                                const data1=JSON.stringify({...data,id:GenerateId,importanceLevel:+data?.importanceLevel})
                                const res=await apiService.addStatusItem(data1);
                                dispatch(AddStatus([res.data,...currentWarings]))
                                openModallComment()
                        }
                            break;
                            case 2:
                                if(toggle==='edit'){
                                    const data1=JSON.stringify({...data,id:penr?.id,importanceLevel:+data?.importanceLevel})
                                const res=await apiService.editStatusSensor(data1);
                                const editedList = [
                                    ...currentWarings.slice(0,iindex),
                                    res.data,
                                    ...currentWarings.slice(iindex+1)
                                  ];
                                dispatch(AddStatus(editedList))
                                openModalls()
                                }
                                if(toggle==='add'){
                                    const data1=JSON.stringify({...data,id:GenerateId,importanceLevel:+data?.importanceLevel})
                                    const res=await apiService.addStatusSensor(data1);
                                    
                                    dispatch(AddStatus([res.data,...currentWarings]))
                                    openModallComment()
                                }
                                break;
                                case 3:
                                if(toggle==='edit'){
                                    const data1=JSON.stringify({...data,id:penr?.id})
                                const res=await apiService.editCycleItem(data1);
                                const editedList = [
                                    ...currentWarings.slice(0,iindex),
                                    res.data,
                                    ...currentWarings.slice(iindex+1)
                                  ];
                                dispatch(AddStatus(editedList))
                                openModalls()
                                }
                                if(toggle==='add'){
                                    const data1=JSON.stringify({...data,id:GenerateId})
                                    const res=await apiService.addCycleItem(data1);
                                    
                                    dispatch(AddStatus([res.data,...currentWarings]))
                                    openModallComment()
                                }
                                break;
                                case 4:
                                if(toggle==='edit'){
                                    const data1=JSON.stringify({...data,id:penr?.id})
                                const res=await apiService.editTypeCattleComment(data1);
                                const editedList = [
                                    ...currentWarings.slice(0,iindex),
                                    res.data,
                                    ...currentWarings.slice(iindex+1)
                                  ];
                                dispatch(AddStatus(editedList))
                                openModalls()
                                }
                                if(toggle==='add'){
                                    const data1=JSON.stringify({...data,id:GenerateId})
                                    const res=await apiService.addTypeCattleComment(data1);
                                    
                                    dispatch(AddStatus([res.data,...currentWarings]))
                                    openModallComment()
                                }
                                break;
                                case 5:
                                if(toggle==='edit'){
                                    const data1=JSON.stringify({...data,id:penr?.id})
                                const res=await apiService.editTypeSensorComment(data1);
                                const editedList = [
                                    ...currentWarings.slice(0,iindex),
                                    res.data,
                                    ...currentWarings.slice(iindex+1)
                                  ];
                                dispatch(AddStatus(editedList))
                                openModalls()
                                }
                                if(toggle==='add'){
                                    const data1=JSON.stringify({...data,id:GenerateId})
                                    const res=await apiService.addTypeSensorComment(data1);
                                    
                                    dispatch(AddStatus([res.data,...currentWarings]))
                                    openModallComment()
                                }
                                break;
                                case 7:
                                if(toggle==='edit'){
                                    const data1=JSON.stringify({...data,id:penr?.id})
                                const res=await apiService.editPenType(data1);
                                const editedList = [
                                    ...currentWarings.slice(0,iindex),
                                    res.data,
                                    ...currentWarings.slice(iindex+1)
                                  ];
                                dispatch(AddStatus(editedList))
                                openModalls()
                                }
                                if(toggle==='add'){
                                    const data1=JSON.stringify({...data,id:GenerateId})
                                    const res=await apiService.addPenType(data1);
                                    
                                    dispatch(AddStatus([res.data,...currentWarings]))
                                    openModallComment()
                                }
                                break;
                                case 8:
                                if(toggle==='edit'){
                                    const data1=JSON.stringify({...data,id:penr?.id})
                                const res=await apiService.editPensCommentsTypes(data1);
                                const editedList = [
                                    ...currentWarings.slice(0,iindex),
                                    res.data,
                                    ...currentWarings.slice(iindex+1)
                                  ];
                                dispatch(AddStatus(editedList))
                                openModalls()
                                }
                                if(toggle==='add'){
                                    const data1=JSON.stringify({...data,id:GenerateId})
                                    const res=await apiService.addPensCommentsTypes(data1);
                                    
                                    dispatch(AddStatus([res.data,...currentWarings]))
                                    openModallComment()
                                }
                                break;
                                case 9:
                                if(toggle==='edit'){
                                    const data1=JSON.stringify({...data,id:penr?.id})
                                const res=await apiService.editCommentFarmTypes(data1);
                                const editedList = [
                                    ...currentWarings.slice(0,iindex),
                                    res.data,
                                    ...currentWarings.slice(iindex+1)
                                  ];
                                dispatch(AddStatus(editedList))
                                openModalls()
                                }
                                if(toggle==='add'){
                                    const data1=JSON.stringify({...data,id:GenerateId})
                                    const res=await apiService.addCommentFarmTypes(data1);
                                    
                                    dispatch(AddStatus([res.data,...currentWarings]))
                                    openModallComment()
                                }
                                break;
                    }
    }
    

    return <div onClick={toggle==='edit'?closeModalls:closeModallComment} className={`modal-overlay ${(toggle==='edit'?isOpenModal:isModalCommentOpen)&&'show-modal'} `}>
        <form onSubmit={handleSubmit(updatePen)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>

            <div className="editModalDamConHead">
            <DriveFileRenameOutlineIcon fontSize="large"/>

            {toggle==='edit'?<h4 >به روز رسانی </h4>:<h4 > افزودن  </h4>}
            </div>
       
            <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("title",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><TitleIcon fontSize='small'/>نام </label>
            {errors?.title?.message&&<span className='errMsg'>{errors.title.message}</span>}
        </div>
        {(flag==1||flag==2)&&<div className="SelConn">
        <label for='sele' ><ImportantDevices fontSize='small'/> اهمیت:</label>
        <select id='sele' name='sele' className="selectInp" {...register("importanceLevel",{required:true})}>
            {important.map(item=>{
                return <option value={item?.id}> {item?.description}</option>
            })}
            
        </select>
        {errors.importanceLevel&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>}
        <button disabled={valid} className="EditMOdalBtnForm" type="submit">
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
    </div>
}
export default EditStatus